/**
 * Define action type for units module
 */
export const GET_UNITS = 'courses/GET_UNITS';
export const GET_UNITS_SUCCESS = 'courses/GET_UNITS_SUCCESS';
